export default {
    baseDomain() {
        return window.API || 'http://localhost:8000/api';
    },
    rootUrl() {
        return window.ROOT || 'http://localhost:8000/';
    },
};